// src/sections/hero/DesktopHero.jsx
import "./DesktopHero.css";
import { useLang } from "../../../../i18n/LangContext";

export default function DesktopHero({ onGetStarted, onContact, speaker = null, id = "welcome" }) {
  const { t } = useLang(); // взимаме активния език

  return (
    <section id={id} className="hero-root hero-desktop" aria-label="Welcome section">
      <div className="hero-wrap">
        {/* Лява колона */}
        <div className="hero-left">
          <p className="hero-eyebrow">{t.home.eyebrow}</p>

          <h1 className="hero-title">
            {Array.isArray(t.home.title) ? (
              <>
                {t.home.title[0]}<br />{t.home.title[1]}
              </>
            ) : t.home.title}
          </h1>

          <p className="hero-desc">{t.home.desc}</p>

          <div className="adv-overview-cta">
            <button className="adv-overview-btn" onClick={onGetStarted}>
              <span className="adv-overview-btn-inner">{t.home.cta.getStarted.toUpperCase()}</span>
            </button>

            <button className="adv-overview-btn adv-overview-btn-ghost" onClick={onContact}>
              <span className="adv-overview-btn-inner">{t.home.cta.contact.toUpperCase()}</span>
            </button>
          </div>
        </div>

        {/* Дясната колона – твоя готов компонент/илюстрации */}
        <div className="hero-right">
          <img src={speaker}></img>
        </div>
      </div>
    </section>
  );
}
